import { render, staticRenderFns } from "./assetsIn.vue?vue&type=template&id=6d1c6e67&scoped=true&"
import script from "./assetsIn.vue?vue&type=script&lang=js&"
export * from "./assetsIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1c6e67",
  null
  
)

export default component.exports